import createOverlappingExcerpts from './OverlappingExcerptMapper';
import calculateInterCoder from './CalculateInterCoder';
import interCoderStats from './InterCoderStats';
import { jaccardWeight } from './WeightFunctions';

function interCoderMapper(excerpts, weightFn = jaccardWeight) {
  // Excerpts are now passed directly, no need to filter from state
  if (!excerpts || !Array.isArray(excerpts)) {
    return {
      score: NaN,
      user_count: 0
    };
  }
  
  const overlappingArray = createOverlappingExcerpts(excerpts);

  // filter out any objects where code_count does not have any keys
  // also the sum of the code count values must be greater than 1
  // TODO: make this better
  const filteredOverlappingArray = overlappingArray.filter((obj) => {
    if ( Object.keys(obj.code_count).length == 0 ) return false;
    if ( Object.values(obj.code_count).reduce((a, b) => a + b, 0) < 2 ) return false;
    return true
  });
  const score = calculateInterCoder(filteredOverlappingArray, weightFn);
  const stats = interCoderStats(excerpts);
  return {
    score,
    ...stats
  };
}

export default interCoderMapper;
